import { h } from 'preact';

// Shared silhouette building blocks for the refresh scenes. All coordinates
// are in the scenes' 800x150 viewBox space. Shapes overdraw generously below
// their baselines so parallax offsets never open gaps between layers.

export const Cloud = ({ x, y, s = 1, fill }) => (
    <g fill={fill} opacity='0.9'>
        <ellipse cx={x} cy={y} rx={26 * s} ry={9 * s} />
        <ellipse cx={x + 14 * s} cy={y - 6 * s} rx={16 * s} ry={7 * s} />
    </g>
);

export const Tree = ({ x, y = 74, s = 1, fill }) => (
    <g fill={fill}>
        <polygon points={`${x},${y} ${x - 11 * s},${y + 26 * s} ${x + 11 * s},${y + 26 * s}`} />
        <rect x={x - 2 * s} y={y + 26 * s} width={4 * s} height={8 * s} />
    </g>
);

export const GroundBand = ({ y = 128, fill }) => (
    <rect x='-100' y={y} width='1000' height='120' fill={fill} />
);
